ReleveBonsImpressionValidator.$inject = ['validator'];

export default function ReleveBonsImpressionValidator(validator) {
	const instance = new validator();
	return instance;
}
